import TRR from "./js/Translation.js";
let RO = TRR.ro;
import DataManager from "./js/DataManager";
import LandingPage from "./components/LoginPage/LandingPage";
import LoginPage from "./components/LoginPage/LoginPage";
import SignUp from "./components/LoginPage/SignUp";
import MainContent from "./components/MainContent";
import DataGrid from "./components/DataGrid";
import DataChart from "./components/DataChart.vue";
import DashBoard from "./components/DashBoard.vue";
import UserFirms from "./components/User/UserFirms.vue";
import UserSettings from "./components/User/UserSettings.vue";
import ObsDeclaration from "./components/User/ObserverDeclaration";
import ObserverSettings from "./components/User/ProfileObserver";
import Payments from "./components/User/UserPayments.vue";
import ChangePass from "./components/User/ChangePassword.vue";
import InvoiceData from "./components/User/ProfileInvoiceData.vue";
import MailBox from "./components/User/MailBox.vue";
import Events from "./components/Devices/DeviceEvents.vue";
import DeviceInformation from "./components/Devices/DeviceInformation";
import Subscriptions from "./components/Devices/DeviceSubscriptions.vue";
import DeviceMap from "./components/Devices/DeviceMap.vue";
import SubCalculator from "./components/Devices/SubCalculator.vue";
// import DeviceSubscriptionChange from "./components/Devices/DeviceSubscriptionChange.vue";
import BalanceLog from "./components/User/BalanceLog.vue";
import DistrPayments from "./components/User/DistributorPayments.vue";
import UserTechnicians from "./components/User/UserTechnicians.vue";
import Help from "./components/LoginPage/HelpView.vue";
import Catalog from "./components/Parts/CatalogView.vue";
import TelemetryCurrent from "./components/Telemetry/TelemetryCurrent.vue";
import TelemetrySchedule from "./components/Telemetry/TelemetrySchedule.vue";
import MaintenanceSchedule from "./components/Telemetry/MaintenanceSchedule.vue";
import DeviceLiveData from "./components/Devices/DeviceLiveData.vue";
import XmlMonthly from "./components/User/XmlMonthly.vue";

export default [
  { name: "login", path: "/login", component: LoginPage, props: true },
  { name: "signup", path: "/signup", component: SignUp, props: true },
  { name: "landing", path: "/landing", component: LandingPage, props: true },
  {
    name: "catalog",
    path: "/catalog",
    component: Catalog,
    meta: { internal: true },
  },
  {
    title: "Tremol Assistant",
    name: "MainContent",
    path: "/MainContent",
    component: MainContent,
    meta: {
      title: "",
      require_login: true,
    },
    children: [
      {
        title: "Входящи съобщения",
        name: "mailbox",
        path: "/bg/mailbox",
        component: MailBox,
        meta: {
          require_login: true,
          title: "Входящи съобщения",
          group: "Входящи съобщения",
          icon: "mdi-email-variant",
          group_icon: "mdi-email-variant",
          datatype: DataManager.DataType.messages,
          for_user: DataManager.UserTypes.All,
          menu_description: "Уведомителна система на потребителя",
          description: "Уведомителна система на потребителя, в която се виждат всички индивидуални съобщения, насочени към него.",
          // video_url: base_video_url + "Входящи_съобщения" + ".mp4", //TODO
          // video_file: require("./assets/video/Входящи_съобщения.mp4"),
        },
      },
      // {
      //   title: "Каталог",
      //   name: "deviceCatalog",
      //   path: "/bg/deviceCatalog",
      //   component: Catalog,
      //   meta: {
      //     require_login: true,
      //     title: "Каталог",
      //     group: "Каталог",
      //     icon: "mdi-tune-variant",
      //     group_icon: "mdi-tune-variant",
      //     datatype: null,
      //     for_user: DataManager.UserTypes.Distributor,
      //     menu_description: "Каталог със съставните части на фискалните устройства.",
      //     description: "Каталог със съставните части на фискалните устройства.",
      //   },
      // },
      {
        title: "Списък с устройства",
        name: "gridDevices",
        path: "/bg/gridDevices",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Списък с устройства",
          group: "Устройства",
          icon: "mdi-format-list-numbered",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Списък с устройствата на потребителя",
          description:
            "Таблично представяне на фискалните устройства.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          video_file: require("./assets/video/gridDevices.mp4"),
        },
      },

      {
        title: "Текущо състояние",
        name: "dashboard",
        path: "/bg/dashboard",
        component: DashBoard,
        meta: {
          require_login: true,
          title: "Текущо състояние",
          group: "Устройства",
          icon: "mdi-home-account",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Обобщена информация за текущото състояние на Вашите фискални устройства",
          description:
            "В това меню се вижда в реално време текущото състояние на всички ФУ, регистрирани на текущия потребител.\nВ него се визуализира обобщена информация за състоянието, продажбите, оборотите за деня, текущата седмица и текущия месец на Вашите устройства.\nПреките пътища 'Оборот по дни' или 'Оборот по седмици' прехвърлят директно в меню 'Графични справки'.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/dashboard.mp4"),
        },
      },
      {
        title: "Данни на живо",
        name: "livedata",
        path: "/bg/livedata",
        component: DeviceLiveData,
        meta: {
          require_login: true,
          title: "Данни на живо",
          group: "Устройства",
          icon: "mdi-access-point",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: TRR.bg.MenuDescription_DevRealTime,
          // description: "",
        },
      },
      {
        title: "Информация за ФУ",
        name: "devices",
        path: "/bg/devices",
        component: DeviceInformation,
        meta: {
          require_login: true,
          title: "Информация за ФУ",
          group: "Устройства",
          icon: "mdi-format-list-text",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Подробна информация за всички Ваши устройства, произведени от Тремол ООД",
          description:
            "Менюто предоставя възможност за:\n • разглеждане на подробна информация за всички ФУ, регистрирани на текущия потребител като адрес на търговски обект, срок на сервизен договор, дата на последна активност и др.;\n • редактиране име на ФУ, име на търговски обект и име на поддържащо лице, предварително добавено в 'Профил' ↪ 'Поддръжка', както и да въвеждате коментар за всяко едно фискално устройство;\n • филтриране по име и сериен номер на ФУ;\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/devices.mp4"),
        },
      },
      {
        title: "Известия",
        name: "events",
        path: "/bg/events",
        component: Events,
        meta: {
          require_login: true,
          title: "Известия",
          group: "Устройства",
          icon: "mdi-bell-ring-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          events: 0,
          description: "Менюто съдържа списък с текущите активни събития за Вашите устройства.\nТук се визуализират и събитията, изпращани от ФУВАС.",
          menu_description: "Текущите активни събития за устройствата Ви",
        },
      },
      {
        title: "Местоположение",
        name: "map",
        path: "/bg/map",
        component: DeviceMap,
        meta: {
          require_login: true,
          title: "Местоположение",
          group: "Устройства",
          icon: "mdi-map-marker-radius-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Карта с местоположението на всяко едно устройство",
          description: "Карта с местоположението на всяко едно от Вашите фискални устройства, разпределени по адреси на търговските обекти, на които са регистрирани.\n\nАкцент върху блокиралите ФУВАС-и.",
        },
      },

      {
        title: "Текущо състояние",
        name: "telemetry",
        path: "/bg/telemetry",
        component: TelemetryCurrent,
        meta: {
          require_login: true,
          title: "Текущо състояние",
          group: "ФУВАС одит",
          icon: "mdi-coffee-outline",
          group_icon: "mdi-coffee-maker",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.OwnerWithTelemetry,
          menu_description: "Текущо състояние на устройствата, спрямо последните получени данни от одит по EVA DTS протокол.",
          description: "",
          video_file: null,
        },
      },
      {
        title: "Справка зареждане",
        name: "telemetryGridSoldQty",
        path: "/bg/telemetryGridSoldQty",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Справка зареждане",
          group: "ФУВАС одит",
          icon: "mdi-coffee-to-go",
          group_icon: "mdi-coffee-maker",
          datatype: DataManager.DataType.telemetry_current,
          for_user: DataManager.UserTypes.OwnerWithTelemetry,
          menu_description: "Справка, която показва изразходените количества продукти от последното зареждане.",
          description: "",
          video_file: null,
        },
      },
      {
        title: "График за одит",
        name: "telemetrySchedule",
        path: "/bg/telemetrySchedule",
        component: TelemetrySchedule,
        meta: {
          require_login: true,
          title: "График за одит",
          group: "ФУВАС одит",
          icon: "mdi-av-timer",
          group_icon: "mdi-coffee-maker",
          datatype: DataManager.DataType.telemetry_current,
          for_user: DataManager.UserTypes.OwnerWithTelemetry, //for_user: DataManager.UserTypes.OwnerWithTelemetry,
          menu_description: "Настройване на времената за автоматично изпращане на данни от одита на ФУВАС.",
          description: "",
          video_file: null,
        },
      },
      {
        title: "График за обслужване",
        name: "maintenanceSchedule",
        path: "/bg/maintenanceSchedule",
        component: MaintenanceSchedule,
        meta: {
          require_login: true,
          title: "График за обслужване",
          group: "ФУВАС одит",
          icon: "mdi-calendar",
          group_icon: "mdi-coffee-maker",
          datatype: null,
          for_user: DataManager.UserTypes.OwnerWithTelemetry,
          menu_description: "описание за обслужването на машини ",
          description: "",
          video_file: null,
        },
      },

      {
        title: "Месечни отчети на ФУ",
        name: "gridMonthly",
        path: "/bg/gridMonthly",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Месечни отчети на ФУ",
          group: "Таблични справки",
          icon: "mdi-calendar-month",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на данните от месечните отчети на фискалните устройства",
          description:
            "Оборотът е групиран по месеци с възможност за:\n • Избор на месец и година.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Дневни отчети",
        name: "gridDaily",
        path: "/bg/gridDaily",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Дневни отчети",
          group: "Таблични справки",
          icon: "mdi-file-table-box-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на данните от дневните (Z) отчети на фискалните устройства",
          description:
            "Оборотът е групиран по дни с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Дневни отчети (сумирани)",
        name: "gridDailyGrouped",
        path: "/bg/gridDailyGrouped",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Дневни отчети (сумирани)",
          group: "Таблични справки",
          icon: "mdi-file-table-box-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports_grouped,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на сумираните данни от дневните (Z) отчети на фискалните устройства",
          description:
            "Оборотът е сумиран по устройства, с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Бонове",
        name: "gridSales",
        path: "/bg/gridSales",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Бонове",
          group: "Таблични справки",
          icon: "mdi-note-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на данните от продажбите по бонове",
          //description: "Таблично представяне на данните от продажбите по бонове.\n Подробна информация за боновете и събитията след кликване върху типа на бона.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          description:
            "Таблично представяне на данните от всички генерирани фискални и други бонове, като има възможност за избор на колони, сортиране по колони, експорт на справка в pdf, csv или xls формат, филтриране по дата, филтриране по тип на бона, както следва (*филтрите са активни, само ако съществува съответното събитие):\n • ФУВАС събитие - показва събития свързани само с Tremol V и Tremol V-KL\n • фактури - суми по издадени фактури\n • кредитно известие - суми по издадени сторно бонове от тип фактури\n • сторно бон - суми по сторно бонове\n • фискален бон - суми по продажби с изключение на фискални бонове от тип фактура\n • статус на ФУ - идва след изпращане на команда към ФУ\n • одит информация - информация за текущо състояние на продукти и съставки в автомати на самообслужване с възможност за редакция на наименованията.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Фактури",
        name: "gridInvoices",
        path: "/bg/gridInvoices",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Фактури",
          group: "Таблични справки",
          icon: "mdi-newspaper-variant-multiple",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.invoices_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на данните от фактурите и кредитните известия",
          //description: "Таблично представяне на данните от продажбите по бонове.\n Подробна информация за боновете и събитията след кликване върху типа на бона.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          description:
            "Таблично представяне на данните от всички генерирани фактури и кредитни известия, като има възможност за избор на колони, сортиране по колони, експорт на справка в pdf, csv или xls формат, филтриране по дата, филтриране по тип на бона, както следва (*филтрите са активни, само ако съществува съответното събитие):\n • фактури - суми по издадени фактури\n • кредитно известие - суми по издадени сторно бонове от тип фактури.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Продажби по артикули",
        name: "gridSalesByItems",
        path: "/bg/gridSalesByItems",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Продажби по артикули",
          group: "Таблични справки",
          icon: "mdi-food-variant",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_articles,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на продажбите по артикули",
          //description: "Таблично представяне на продажбите от всички фискални устройства, групирани по артикули.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          description:
            "Таблично представяне на натрупания оборот по артикули и департаменти, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Филтриране по тип на фискалния бон.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Продажби по цени",
        name: "gridSalesByPrice",
        path: "/bg/gridSalesByPrice",
        component: DataGrid,
        meta: {
          require_login: true,
          title: "Продажби по цени",
          group: "Таблични справки",
          icon: "mdi-compare-vertical",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Таблично представяне на продажбите по цени",
          //description: "Таблично представяне на продажбите от всички фискални устройства, групирани по артикули.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          description:
            "Таблично представяне на продажбите по цени, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: "Месечни отчети",
        name: "chartMonthly",
        path: "/bg/chartMonthly",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Месечни отчети",
          group: "Графични справки",
          icon: "mdi-chart-line",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на данните от месечните отчети",
          //description: "Графично представяне на данните от месечните отчети на фискалните устройства.\n Възможност за:\n• Промяна на изгледа на графиката.\n• Мащабиране (приближаване и отдалечаване).\n• Експорт във файл с изображение.",
          description:
            "Графично представяне на данните от месечните отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Дневни отчети",
        name: "chartDaily",
        path: "/bg/chartDaily",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Дневни отчети",
          group: "Графични справки",
          icon: "mdi-chart-multiple",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на данните от дневните (Z) отчети",
          //description: "Графично представяне на данните от дневните (Z) отчети на фискалните устройства. Възможност за:\n• Промяна на изгледа на графиката.\n• Мащабиране (приближаване и отдалечаване).\n• Експорт във файл с изображение.",
          description:
            "Графично представяне на данните от дневните (Z) отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Оборот по часове",
        name: "chartHourlyPrice",
        path: "/bg/chartHourlyPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Оборот по часове",
          group: "Графични справки",
          icon: "mdi-chart-timeline-variant-shimmer",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на оборота по часове",
          //description: "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали.\n Възможност за:\n• Промяна на изгледа на графиката.\n• Мащабиране (приближаване и отдалечаване).\n• Експорт във файл с изображение.",
          description:
            "Графично представяне на обоборта по часове за всяко фискално устройство. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Натовареност по часове",
        name: "chartHourlyQty",
        path: "/bg/chartHourlyQty",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Натовареност по часове",
          group: "Графични справки",
          icon: "mdi-chart-timeline-variant",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_qty,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на продадените количества по часове",
          //description: "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали.\n Възможност за:\n• Промяна на изгледа на графиката.\n• Мащабиране (приближаване и отдалечаване).\n• Експорт във файл с изображение.",
          description:
            "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали с възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Продажби по цени",
        name: "chartSalesByPrice",
        path: "/bg/chartSalesByPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Продажби по цени",
          group: "Графични справки",
          icon: "mdi-chart-bar-stacked",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на продажбите, групирани по единична цена",
          //description: "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали.\n Възможност за:\n• Промяна на изгледа на графиката.\n• Мащабиране (приближаване и отдалечаване).\n• Експорт във файл с изображение.",
          description:
            "Графично представяне на продажбите, групирани по единична цена. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Видове плащания по дни",
        name: "chartPayments",
        path: "/bg/chartPayments",
        component: DataChart,
        meta: {
          require_login: true,
          title: "Видове плащания по дни",
          group: "Графични справки",
          icon: "mdi-chart-box-outline",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_payments,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Графично представяне на видовете плащания по дни.",
          //description: "Графично представяне на видовете плащания по дни.\n Възможност за промяна на типа на графиката.\n Възможност за мащабиране (приближаване и отдалечаване). \nВъзможност за експорт във файл с изображение.",
          description:
            "Графично представяне на видовете плащания по дни, с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Фирми на потребителя",
        name: "clients",
        path: "/bg/clients",
        component: UserFirms,
        meta: {
          require_login: true,
          title: "Фирми на потребителя",
          group: "Абонамент",
          icon: "mdi-account-group-outline",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.clients,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Списък с фирми на потребителя",
          description:
            "Менюто съдържа списък с всички фирми, които потребителят е добавил към акаунта си.\nВъзможност за генериране и изпращане на нотариално заверена или електронно подписана декларация, която е по изискване на Наредба Н-18 от 02 юли 2019 година.",
          video_file: require("./assets/video/clients.mp4"),
        },
      },
      {
        title: "Абониране на ФУ",
        name: "subscription",
        path: "/bg/subscription",
        component: Subscriptions,
        meta: {
          require_login: true,
          title: "Абониране на ФУ",
          group: "Абонамент",
          icon: "mdi-account-cash-outline",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Активиране/деактивиране на абонаментен план за всяко фискално устройство.",
          //description: "Дава възможност за избор на индивидуален абонаментен план за всяко фискално устройство.\n В зависимост от избрания абонаментен план, устройството ще изпраща съответните данни:\n • Фискални бонове и събития.\n • Дневни отчети.\n • Месечни отчети.",
          description:
            "Дава възможност за активиране/деактивиране на избран индивидуален абонаментен план за всяко фискално устройство.\nВ зависимост от избрания абонаментен план, устройството ще изпраща съответните данни:\n • Фискални бонове и събития.\n • Дневни отчети.\n • Месечни отчети.",
          video_file: require("./assets/video/subscription.mp4"),
        },
      },

      {
        title: "Движение по сметка",
        name: "balanceLog",
        path: "/bg/balanceLog",
        component: BalanceLog,
        meta: {
          require_login: true,
          title: "Движение по сметка",
          group: "Абонамент",
          icon: "mdi-cash-refund",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.balance_charges,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Подробна информация за дневното таксуване и извършените плащания.",
          //description: "Менюто изобразява таблично дневното таксуване за абонираните устройства обобщено по дни, както и извършените плащания.\nПотребителят има възможност да види за всеки таксуван ден подробна информация, съдържаща всички таксувани устройства на този ден.",
          description: "Менюто изобразява таблично движението на суми за всяко едно ФУ според индивидуалния му абонаментен план за всеки ден, захранванията по сметка, както и фактури за плащания, в случай че потребителят заплаща директно на Тремол ООД.",
          video_file: require("./assets/video/balanceLog.mp4"),
        },
      },
      // TODO Тошо като оправи POST заявката WebPms/cosmos/Devices/GetSubscriptionsLog
      // {
      //   title: "Движение на абонамент",
      //   name: "subscriptionChanges",
      //   path: "/bg/subscriptionChanges",
      //   component: DeviceSubscriptionChange,
      //   meta: {
      //     require_login: true,
      //     title: "Движение на абонамент",
      //     group: "Абонамент",
      //     icon: "mdi-vector-polyline-plus",
      //     group_icon: "mdi-account-cash-outline",
      //     datatype: DataManager.DataType.devices,
      //     for_user: DataManager.UserTypes.Owner,
      //     menu_description: "Активиране/деактивиране на абонаментен план за всяко фискално устройство.",
      //     //description: "Дава възможност за избор на индивидуален абонаментен план за всяко фискално устройство.\n В зависимост от избрания абонаментен план, устройството ще изпраща съответните данни:\n • Фискални бонове и събития.\n • Дневни отчети.\n • Месечни отчети.",
      //     description: "Дава възможност за активиране/деактивиране на избран индивидуален абонаментен план за всяко фискално устройство.\nВ зависимост от избрания абонаментен план, устройството ще изпраща съответните данни:\n • Фискални бонове и събития.\n • Дневни отчети.\n • Месечни отчети.",
      //     video_file: require("./assets/video/subscription.mp4"),
      //   },
      // },
      {
        title: "Assistant плащане",
        name: "distributorPayments",
        path: "/bg/distributorPayments",
        component: DistrPayments,
        meta: {
          require_login: true,
          title: "Assistant плащане",
          group: "Assistant плащане",
          icon: "mdi-cash-refund",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.balance_payments,
          for_user: DataManager.UserTypes.Distributor,
          menu_description: "Добавяне на Tremol Assistant плащане за краен клиент.",
          description: "Менюто се използва за добавяне на Tremol Assistant плащане за краен клиент. Плащането ще бъде фактурирано към дистрибутора (Вас).",
        },
      },
      {
        title: "Калкулатор",
        name: "subCalculator",
        path: "/bg/subCalculator",
        component: SubCalculator,
        meta: {
          require_login: true,
          title: "Калкулатор",
          group: "Абонамент",
          icon: "mdi-calculator",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.subscription_plans,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Калкулиране на разходите спрямо избраните абонаментни планове.",
          //description: "Калкулатор за абонамент, чрез който можете да изчислите и планирате потреблението на Вашите устройства, спрямо избраните индивидуални абонаментни планове.",
          description:
            "Калкулатор за абонамент, чрез който може да се планира потреблението на устройствата на потребителя. Предоставя възможност за изчисляване на срока на абонамент според вложените средства, както и изчисляване на необходимите средства за определен период на абонамент.",
          video_file: require("./assets/video/subCalculator.mp4"),
        },
      },
      {
        title: "Калкулатор",
        name: "distributorCalculator",
        path: "/bg/distributorCalculator",
        component: SubCalculator,
        meta: {
          require_login: true,
          title: "Калкулатор",
          group: "Калкулатор",
          icon: "mdi-calculator",
          group_icon: "mdi-account-cash-outline",
          datatype: DataManager.DataType.subscription_plans,
          for_user: DataManager.UserTypes.Distributor,
          menu_description: "Калкулиране на разходите спрямо избраните абонаментни планове.",
          //description: "Калкулатор за абонамент, чрез който можете да изчислите и планирате потреблението на Вашите устройства, спрямо избраните индивидуални абонаментни планове.",
          description:
            "Калкулатор за абонамент, чрез който може да се планира потреблението на устройствата на потребителя. Предоставя възможност за изчисляване на срока на абонамент според вложените средства, както и изчисляване на необходимите средства за определен период на абонамент.",
          video_file: require("./assets/video/subCalculator.mp4"),
        },
      },
      {
        title: "Плащане",
        name: "payments",
        path: "/bg/payments",
        component: Payments,
        meta: {
          title: "Плащане",
          require_login: true,
          icon: "mdi-bank-transfer",
          group: "Абонамент", // "Профил"
          group_icon: "mdi-account-cash-outline", //group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,

          menu_description: "Генериране на основание за плащане към Тремол ООД.",
          //description: "В това меню можете да си генерирате основание за плащане по банков път към Тремол ООД, в случай че плащането няма да минава през обслужващата Ви фирма.",
          description: "В това меню може да генерирате основание за плащане по банков път към Тремол ООД, в случай че плащането няма да минава през обслужващата Ви фирма.",
        },
      },
      {
        title: "Декларация",
        name: "obsDeclaration",
        path: "/bg/obsDeclaration",
        component: ObsDeclaration,
        meta: {
          require_login: true,
          title: "Декларация",
          icon: "mdi-file-document-edit-outline",
          group: "Профил",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Observer,
          menu_description: "Декларация, идентифицираща фирмата ползвател",
          description: "От това меню можете да видите, изтеглите и качите декларация, идентифицираща Вашата фирмата. Декларацията е необходима, за да бъдат избегнати евентуални злоупотреби от трети лица, представящи се за Вас.",
        },
      },
      {
        title: "Поддръжка",
        name: "technicians",
        path: "/bg/technicians",
        component: UserTechnicians,
        meta: {
          force_load: true,
          require_login: true,
          title: "Поддръжка",
          group: "Профил",
          icon: "mdi-progress-wrench",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Добавяне и редактиране на списък с лица за поддръжка.",
          //description: "В това меню може да конфигурирате номенклатурата с лицата за поддръжка, които обслужват устройствата.",
          description: "В това меню се добавят лица отговарящи за определен брой фискални устройства в даден район. Обвързването им с ФУ се извършва от меню 'Устройства' ↪ 'Информация за ФУ' с редактиране на поле 'Поддръжка'.",
          video_file: require("./assets/video/technicians.mp4"),
        },
      },
      {
        title: "Данни за фактура",
        name: "invoiceData",
        path: "/bg/invoiceData",
        component: InvoiceData,
        meta: {
          require_login: true,
          title: "Данни за фактура",
          icon: "mdi-file-document-edit-outline",
          group: "Профил",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Данни за издаване на фактура от Тремол ООД",
          //description: "Ако извършвате плащания директно към Тремол ООД е необходимо да попълните изисканите данни, които да влязат в издаваната към Вас фактура.",
          description: "В случай, че плащанията се извършват директно към Тремол ООД, тук трябва да попълните данните, които ще са необходими за издаването на фактура.",
        },
      },
      {
        title: "Наблюдаващ профил",
        name: "observer",
        path: "/bg/observer",
        component: ObserverSettings,
        meta: {
          require_login: true,
          title: "Наблюдаващ профил",
          group: "Профил",
          icon: "mdi-account-tie",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,
          menu_description: "Добавяне на потребител, който да наблюдава данните от Вашите фискални устройства",
          //description: "Менюто служи за добавяне на наблюдаващ профил.\nНаблюдаващият профил трябва да бъде предварително регистриран и одобрен в системата, като регистрацията е безплатна.\nНаблюдаващият профил ще има достъп до данните от продажбите и отчетите Ви, но няма да може да редактира.\nЕдин потребител може да има само един наблюдаващ профил.",
          description:
            "Менюто служи за добавяне на наблюдаващ профил (например счетоводител). Той трябва да бъде предварително регистриран и одобрен в системата, като регистрацията е безплатна.\nПотребителят с права на наблюдател ще има достъп до данните от устройствата Ви, но няма да може да редактира или променя абонаментните им планове.\nЕдин потребител може да има само един наблюдаващ профил.",
          video_file: require("./assets/video/observer.mp4"),
        },
      },
      {
        title: "Смяна на парола",
        name: "changePass",
        path: "/bg/changePass",
        component: ChangePass,
        meta: {
          require_login: true,
          title: "Смяна на парола",
          group: "Профил",
          icon: "mdi-account-key-outline",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: "Смяна на текущата парола на потребителя",
          description: "Менюто служи за смяна на текущата парола на потребителя.",
        },
      },
      {
        title: "Настройки",
        name: "settings",
        path: "/bg/settings",
        component: UserSettings,
        meta: {
          require_login: true,
          title: "Настройки",
          group: "Настройки",
          icon: "mdi-message-cog-outline",
          group_icon: "mdi-account-cog-outline",
          datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.All,
          menu_description: "Конфигуриране интерфейса на приложението",
          description: "В това меню може да конфигурирате потребителския интерфейс за Вашия профил.\n • 'Тъмна' тема на приложението.\n • 'Свит' режим на табличните справки.\n • Показване/скриване на помощните балончета на приложението.",
        },
      },

      {
        title: "Помощ",
        name: "help",
        path: "/bg/help",
        component: Help,
        meta: {
          require_login: true,
          title: "Помощ",
          group: "Помощ",
          icon: "mdi-help-circle-outline",
          group_icon: "mdi-help-circle-outline",
          for_user: DataManager.UserTypes.All,
          menu_description: "Помощно меню за работа с приложението.",
          description: "Помощно меню за работа с приложението.",
        },
      },

      // {
      //   title: RO.InnerMessages,
      //   name: "ro_mailbox",
      //   path: "/ro/mailbox",
      //   component: MailBox,
      //   meta: {
      //     require_login: true,
      //     title: RO.InnerMessages,
      //     group: RO.InnerMessages,
      //     icon: "mdi-email-variant",
      //     group_icon: "mdi-email-variant",
      //     datatype: DataManager.DataType.messages,
      //     for_user: DataManager.UserTypes.All,
      //     menu_description: RO.MenuDescription_Mailbox,
      //     // description: "Уведомителна система на потребителя, в която се виждат всички индивидуални съобщения, насочени към него.",
      //     // video_url: base_video_url + "Входящи_съобщения" + ".mp4", //TODO
      //     // video_file: require("./assets/video/Входящи_съобщения.mp4"),
      //   },
      // },

      {
        title: RO.DeviceList,
        name: "ro_gridDevices",
        path: "/ro/gridDevices",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DeviceList,
          group: RO.Devices,
          icon: "mdi-format-list-numbered",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_GridDevices,
          // description: "Таблично представяне на фискалните устройства.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          // video_file: require("./assets/video/gridDevices.mp4"),
        },
      },
      {
        title: RO.CurrentStatus,
        name: "ro_dashboard",
        path: "/ro/dashboard",
        component: DashBoard,
        meta: {
          require_login: true,
          title: RO.CurrentStatus,
          group: RO.Devices,
          icon: "mdi-home-account",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DevStatus,
          // description: "В това меню се вижда в реално време текущото състояние на всички ФУ, регистрирани на текущия потребител.\nВ него се визуализира обобщена информация за състоянието, продажбите, оборотите за деня, текущата седмица и текущия месец на Вашите устройства.\nПреките пътища 'Оборот по дни' или 'Оборот по седмици' прехвърлят директно в меню 'Графични справки'.\nДопълнително меню   създаване на персонализирани филтри.",
          // video_file: require("./assets/video/dashboard.mp4"),
        },
      },
      {
        title: RO.DeviceLiveData,
        name: "ro_livedata",
        path: "/ro/livedata",
        component: DeviceLiveData,
        meta: {
          require_login: true,
          title: RO.DeviceLiveData,
          group: RO.Devices,
          icon: "mdi-access-point",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DevRealTime,
          // description: "",
        },
      },
      {
        title: RO.Device_Info,
        name: "ro_devices",
        path: "/ro/devices",
        component: DeviceInformation,
        meta: {
          require_login: true,
          title: RO.Device_Info,
          group: RO.Devices,
          icon: "mdi-format-list-text",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DevInfo,
          // description: "Менюто предоставя възможност за:\n • разглеждане на подробна информация за всички ФУ, регистрирани на текущия потребител като адрес на търговски обект, срок на сервизен договор, дата на последна активност и др.;\n • редактиране име на ФУ, име на търговски обект и име на поддържащо лице, предварително добавено в 'Профил' ↪ 'Поддръжка', както и да въвеждате коментар за  едно фискално устройство;\n • филтриране по име и сериен номер на ФУ;\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/devices.mp4"),
        },
      },
      {
        title: RO.Alarms,
        name: "ro_events",
        path: "/ro/events",
        component: Events,
        meta: {
          require_login: true,
          title: RO.Alarms,
          group: RO.Devices,
          icon: "mdi-bell-ring-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_Alarms,
          // description: "Менюто съдържа списък с текущите активни събития за Вашите устройства.\nТук се визуализират и събитията, изпращани от ФУВАС.",
        },
      },
      {
        title: RO.Location,
        name: "ro_map",
        path: "/ro/map",
        component: DeviceMap,
        meta: {
          require_login: true,
          title: RO.Location,
          group: RO.Devices,
          icon: "mdi-map-marker-radius-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner,
          menu_description: RO.MenuDescription_Location,
          description: "Карта с местоположението на всяко едно от Вашите фискални устройства, разпределени по адреси на търговските обекти, на които са регистрирани.\n\nАкцент върху блокиралите ФУВАС-и.",
        },
      },
      {
        title: RO.MonthlyReports,
        name: "ro_gridMonthly",
        path: "/ro/gridMonthly",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.MonthlyReports,
          group: RO.ReportsGrid,
          icon: "mdi-calendar-month",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_MonthlyReports,
          // description: "Оборотът е групиран по месеци с възможност за:\n • Избор на месец и година.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.DailyReports,
        name: "ro_gridDaily",
        path: "/ro/gridDaily",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DailyReports,
          group: RO.ReportsGrid,
          icon: "mdi-file-table-box-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DailyReports,
          // description: "Оборотът е групиран по дни с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.DailyReportsGrouped,
        name: "ro_gridDailyGrouped",
        path: "/ro/gridDailyGrouped",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DailyReportsGrouped,
          group: RO.ReportsGrid,
          icon: "mdi-file-table-box-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports_grouped,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DailyReportsGrouped,
          // description: "Оборотът е сумиран по устройства, с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.Receipts,
        name: "ro_gridSales",
        path: "/ro/gridSales",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.Receipts,
          group: RO.ReportsGrid,
          icon: "mdi-note-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_Sales,
          // description:"Таблично представяне на данните от всички генерирани фискални и други бонове, като има възможност за избор на колони, сортиране по колони, експорт на справка в pdf, csv или xls формат, филтриране по дата, филтриране по тип на бона, както следва (*филтрите са активни, само ако съществува съответното събитие):\n • ФУВАС събитие - показва събития свързани само с Tremol V и Tremol V-KL\n • фактури - суми по издадени фактури\n • кредитно известие - суми по издадени сторно бонове от тип фактури\n • сторно бон - суми по сторно бонове\n • фискален бон - суми по продажби с изключение на фискални бонове от тип фактура\n • статус на ФУ - идва след изпращане на команда към ФУ\n • одит информация - информация за текущо състояние на продукти и съставки в автомати на самообслужване с възможност за редакция на наименованията.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.SalesByItems,
        name: "ro_gridSalesByItems",
        path: "/ro/gridSalesByItems",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.SalesByItems,
          group: RO.ReportsGrid,
          icon: "mdi-food-variant",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_articles,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_SalesByItems,
          //description: "Таблично представяне на продажбите от всички фискални устройства, групирани по артикули.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          // description: "Таблично представяне на натрупания оборот по артикули и департаменти, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Филтриране по тип на фискалния бон.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.SalesByPrices,
        name: "ro_gridSalesByPrice",
        path: "/ro/gridSalesByPrice",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.SalesByPrices,
          group: RO.ReportsGrid,
          icon: "mdi-compare-vertical",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_SalesByPrices,
          // description: "Таблично представяне на продажбите по цени, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.MonthlyReports,
        name: "ro_chartMonthly",
        path: "/ro/chartMonthly",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.MonthlyReports,
          group: RO.ReportsChart,
          icon: "mdi-chart-line",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartMonthly,
          // description: "Графично представяне на данните от месечните отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.DailyReports,
        name: "ro_chartDaily",
        path: "/ro/chartDaily",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.DailyReports,
          group: RO.ReportsChart,
          icon: "mdi-chart-multiple",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartDaily,
          // description: "Графично представяне на данните от дневните (Z) отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.TurnoverByHours,
        name: "ro_chartHourlyPrice",
        path: "/ro/chartHourlyPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.TurnoverByHours,
          group: RO.ReportsChart,
          icon: "mdi-chart-timeline-variant-shimmer",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartHourly,
          // description: "Графично представяне на обоборта по часове за всяко фискално устройство. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.ActivityByHours,
        name: "ro_chartHourlyQty",
        path: "/ro/chartHourlyQty",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.ActivityByHours,
          group: RO.ReportsChart,
          icon: "mdi-chart-timeline-variant",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_qty,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartHourlyQTY,
          // description: "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали с възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.SalesByPrices,
        name: "ro_chartSalesByPrice",
        path: "/ro/chartSalesByPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.SalesByPrices,
          group: RO.ReportsChart,
          icon: "mdi-chart-bar-stacked",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartByPrice,
          // description: "Графично представяне на продажбите, групирани по единична цена. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.PaymentTypesByDays,
        name: "ro_chartPayments",
        path: "/ro/chartPayments",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.PaymentTypesByDays,
          group: RO.ReportsChart,
          icon: "mdi-chart-box-outline",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_payments,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartPaymentsByDays,
          // description: "Графично представяне на видовете плащания по дни, с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: "Xml ANAF copie",
        name: "ro_xmlAnaf",
        path: "/ro/xmlAnaf",
        component: XmlMonthly,
        meta: {
          require_login: true,
          force_load: true,
          title: "Xml ANAF copie",
          group: "Alte rapoarte",
          icon: "mdi-xml",
          group_icon: "mdi-shape-outline",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.OwnerWithXML,
          menu_description: "",
          // description: "Графично представяне на данните от месечните отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.Technician,
        name: "ro_technicians",
        path: "/ro/technicians",
        component: UserTechnicians,
        meta: {
          force_load: true,
          require_login: true,
          title: RO.Technician,
          group: RO.Profile,
          icon: "mdi-progress-wrench",
          group_icon: "mdi-account-cog-outline",
          datatype: null, // DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,
          menu_description: RO.MenuDescription_Technicians,
          // description: "В това меню се добавят лица отговарящи за определен брой фискални устройства в даден район. Обвързването им с ФУ се извършва от меню 'Устройства' ↪ 'Информация за ФУ' с редактиране на поле 'Поддръжка'.",
          // video_file: require("./assets/video/technicians.mp4"),
        },
      },
      {
        title: RO.Settings,
        name: "ro_settings",
        path: "/ro/settings",
        component: UserSettings,
        meta: {
          require_login: true,
          title: RO.Settings,
          group: RO.Profile,
          icon: "mdi-message-cog-outline",
          group_icon: "mdi-account-cog-outline",
          // datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.All,
          menu_description: RO.MenuDescription_Interface,
          // description: "В това меню може да конфигурирате потребителския интерфейс за Вашия профил.\n • 'Тъмна' тема на приложението.\n • 'Свит' режим на табличните справки.\n • Показване/скриване на помощните балончета на приложението.",
        },
      },

      {
        title: RO.DeviceList,
        name: "md_gridDevices",
        path: "/md/gridDevices",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DeviceList,
          group: RO.Devices,
          icon: "mdi-format-list-numbered",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_GridDevices,
          // description: "Таблично представяне на фискалните устройства.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          // video_file: require("./assets/video/gridDevices.mp4"),
        },
      },
      {
        title: RO.CurrentStatus,
        name: "md_dashboard",
        path: "/md/dashboard",
        component: DashBoard,
        meta: {
          require_login: true,
          title: RO.CurrentStatus,
          group: RO.Devices,
          icon: "mdi-home-account",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DevStatus,
          // description: "В това меню се вижда в реално време текущото състояние на всички ФУ, регистрирани на текущия потребител.\nВ него се визуализира обобщена информация за състоянието, продажбите, оборотите за деня, текущата седмица и текущия месец на Вашите устройства.\nПреките пътища 'Оборот по дни' или 'Оборот по седмици' прехвърлят директно в меню 'Графични справки'.\nДопълнително меню   създаване на персонализирани филтри.",
          // video_file: require("./assets/video/dashboard.mp4"),
        },
      },
      {
        title: RO.Device_Info,
        name: "md_devices",
        path: "/md/devices",
        component: DeviceInformation,
        meta: {
          require_login: true,
          title: RO.Device_Info,
          group: RO.Devices,
          icon: "mdi-format-list-text",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DevInfo,
          // description: "Менюто предоставя възможност за:\n • разглеждане на подробна информация за всички ФУ, регистрирани на текущия потребител като адрес на търговски обект, срок на сервизен договор, дата на последна активност и др.;\n • редактиране име на ФУ, име на търговски обект и име на поддържащо лице, предварително добавено в 'Профил' ↪ 'Поддръжка', както и да въвеждате коментар за  едно фискално устройство;\n • филтриране по име и сериен номер на ФУ;\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/devices.mp4"),
        },
      },
      {
        title: RO.Alarms,
        name: "md_events",
        path: "/md/events",
        component: Events,
        meta: {
          require_login: true,
          title: RO.Alarms,
          group: RO.Devices,
          icon: "mdi-bell-ring-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_Alarms,
          // description: "Менюто съдържа списък с текущите активни събития за Вашите устройства.\nТук се визуализират и събитията, изпращани от ФУВАС.",
        },
      },
      {
        title: RO.Location,
        name: "md_map",
        path: "/md/map",
        component: DeviceMap,
        meta: {
          require_login: true,
          title: RO.Location,
          group: RO.Devices,
          icon: "mdi-map-marker-radius-outline",
          group_icon: "mdi-deskphone",
          datatype: DataManager.DataType.devices,
          for_user: DataManager.UserTypes.Owner,
          menu_description: RO.MenuDescription_Location,
          description: "Карта с местоположението на всяко едно от Вашите фискални устройства, разпределени по адреси на търговските обекти, на които са регистрирани.\n\nАкцент върху блокиралите ФУВАС-и.",
        },
      },
      {
        title: RO.MonthlyReports,
        name: "md_gridMonthly",
        path: "/md/gridMonthly",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.MonthlyReports,
          group: RO.ReportsGrid,
          icon: "mdi-calendar-month",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_MonthlyReports,
          // description: "Оборотът е групиран по месеци с възможност за:\n • Избор на месец и година.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.DailyReports,
        name: "md_gridDaily",
        path: "/md/gridDaily",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DailyReports,
          group: RO.ReportsGrid,
          icon: "mdi-file-table-box-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DailyReports,
          // description: "Оборотът е групиран по дни с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.DailyReportsGrouped,
        name: "md_gridDailyGrouped",
        path: "/md/gridDailyGrouped",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.DailyReportsGrouped,
          group: RO.ReportsGrid,
          icon: "mdi-file-table-box-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.daily_reports_grouped,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_DailyReportsGrouped,
          // description: "Оборотът е сумиран по устройства, с възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.Receipts,
        name: "md_gridSales",
        path: "/md/gridSales",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.Receipts,
          group: RO.ReportsGrid,
          icon: "mdi-note-multiple-outline",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_Sales,
          // description:"Таблично представяне на данните от всички генерирани фискални и други бонове, като има възможност за избор на колони, сортиране по колони, експорт на справка в pdf, csv или xls формат, филтриране по дата, филтриране по тип на бона, както следва (*филтрите са активни, само ако съществува съответното събитие):\n • ФУВАС събитие - показва събития свързани само с Tremol V и Tremol V-KL\n • фактури - суми по издадени фактури\n • кредитно известие - суми по издадени сторно бонове от тип фактури\n • сторно бон - суми по сторно бонове\n • фискален бон - суми по продажби с изключение на фискални бонове от тип фактура\n • статус на ФУ - идва след изпращане на команда към ФУ\n • одит информация - информация за текущо състояние на продукти и съставки в автомати на самообслужване с възможност за редакция на наименованията.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.SalesByItems,
        name: "md_gridSalesByItems",
        path: "/md/gridSalesByItems",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.SalesByItems,
          group: RO.ReportsGrid,
          icon: "mdi-food-variant",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_articles,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_SalesByItems,
          //description: "Таблично представяне на продажбите от всички фискални устройства, групирани по артикули.\n Възможност за:\n• Експортиране към pdf, xls, csv файл.\n• Филтриране.\n• Сортиране.\n•  Скриване на колони.\n Допълнително меню чрез натискане на десен бутон на мишката върху ред от таблицата.",
          // description: "Таблично представяне на натрупания оборот по артикули и департаменти, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Филтриране по тип на фискалния бон.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.SalesByPrices,
        name: "md_gridSalesByPrice",
        path: "/md/gridSalesByPrice",
        component: DataGrid,
        meta: {
          require_login: true,
          title: RO.SalesByPrices,
          group: RO.ReportsGrid,
          icon: "mdi-compare-vertical",
          group_icon: "mdi-view-grid-outline",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_SalesByPrices,
          // description: "Таблично представяне на продажбите по цени, като има възможност за:\n • Избор на период.\n • Избор на колони.\n • Сортиране по колони.\n • Експорт на справка в pdf, csv или xls формат.\nЧрез натискане на десен бутон на мишката върху ред от таблицата има възможност за работа с допълнително меню.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/grid.mp4"),
        },
      },
      {
        title: RO.MonthlyReports,
        name: "md_chartMonthly",
        path: "/md/chartMonthly",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.MonthlyReports,
          group: RO.ReportsChart,
          icon: "mdi-chart-line",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.monthly,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartMonthly,
          // description: "Графично представяне на данните от месечните отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.DailyReports,
        name: "md_chartDaily",
        path: "/md/chartDaily",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.DailyReports,
          group: RO.ReportsChart,
          icon: "mdi-chart-multiple",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.daily_reports,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartDaily,
          // description: "Графично представяне на данните от дневните (Z) отчети с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.TurnoverByHours,
        name: "md_chartHourlyPrice",
        path: "/md/chartHourlyPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.TurnoverByHours,
          group: RO.ReportsChart,
          icon: "mdi-chart-timeline-variant-shimmer",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartHourly,
          // description: "Графично представяне на обоборта по часове за всяко фискално устройство. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.ActivityByHours,
        name: "md_chartHourlyQty",
        path: "/md/chartHourlyQty",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.ActivityByHours,
          group: RO.ReportsChart,
          icon: "mdi-chart-timeline-variant",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_hours_qty,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartHourlyQTY,
          // description: "Графично представяне на продадените количества по часове за всяко фискално устройство. Изключително полезно за оценяване на натоварването на търговския обект във времевите интервали с възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.SalesByPrices,
        name: "md_chartSalesByPrice",
        path: "/md/chartSalesByPrice",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.SalesByPrices,
          group: RO.ReportsChart,
          icon: "mdi-chart-bar-stacked",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_article_price,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartByPrice,
          // description: "Графично представяне на продажбите, групирани по единична цена. Възможност за:\n • Промяна на изгледа на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.PaymentTypesByDays,
        name: "md_chartPayments",
        path: "/md/chartPayments",
        component: DataChart,
        meta: {
          require_login: true,
          title: RO.PaymentTypesByDays,
          group: RO.ReportsChart,
          icon: "mdi-chart-box-outline",
          group_icon: "mdi-chart-bell-curve-cumulative",
          datatype: DataManager.DataType.sales_by_payments,
          for_user: DataManager.UserTypes.Owner + DataManager.UserTypes.Observer,
          menu_description: RO.MenuDescription_ChartPaymentsByDays,
          // description: "Графично представяне на видовете плащания по дни, с възможност за:\n • Избор на изглед на графиката.\n • Мащабиране (приближаване и отдалечаване).\n • Експорт във файл с изображение.\nДопълнително меню за създаване на персонализирани филтри.",
          // video_file: require("./assets/video/chart.mp4"),
        },
      },
      {
        title: RO.Technician,
        name: "md_technicians",
        path: "/md/technicians",
        component: UserTechnicians,
        meta: {
          force_load: true,
          require_login: true,
          title: RO.Technician,
          group: RO.Profile,
          icon: "mdi-progress-wrench",
          group_icon: "mdi-account-cog-outline",
          datatype: null, // DataManager.DataType.user,
          for_user: DataManager.UserTypes.Owner,
          menu_description: RO.MenuDescription_Technicians,
          // description: "В това меню се добавят лица отговарящи за определен брой фискални устройства в даден район. Обвързването им с ФУ се извършва от меню 'Устройства' ↪ 'Информация за ФУ' с редактиране на поле 'Поддръжка'.",
          // video_file: require("./assets/video/technicians.mp4"),
        },
      },
      {
        title: RO.Settings,
        name: "md_settings",
        path: "/md/settings",
        component: UserSettings,
        meta: {
          require_login: true,
          title: RO.Settings,
          group: RO.Profile,
          icon: "mdi-message-cog-outline",
          group_icon: "mdi-account-cog-outline",
          // datatype: DataManager.DataType.user,
          for_user: DataManager.UserTypes.All,
          menu_description: RO.MenuDescription_Interface,
          // description: "В това меню може да конфигурирате потребителския интерфейс за Вашия профил.\n • 'Тъмна' тема на приложението.\n • 'Свит' режим на табличните справки.\n • Показване/скриване на помощните балончета на приложението.",
        },
      },
    ],
  },
  {
    name: "catchAll0",
    path: "/ro",
    redirect: () => {
      // the function receives the target route as the argument we return a redirect path/location here.
      return { path: "/login", query: { lang: "ro" } };
    },
  },
  {
    name: "catchAll1",
    path: "/md",
    redirect: () => {
      // the function receives the target route as the argument we return a redirect path/location here.
      return { path: "/login", query: { lang: "md" } };
    },
  },

  { name: "catchAllx", path: "/*", redirect: "/landing" },
  { name: "catchAlly", path: "*", redirect: "/landing" },
  { name: "catchAllz", path: "/*/", redirect: "/landing" },
  { name: "empty", path: "/", redirect: "/landing" },
];
